import React from "react";
import Button, { type ButtonProps } from "@mui/material/Button";
import type { SxProps, Theme } from "@mui/material/styles";

const dialogSecondaryActionSx: SxProps<Theme> = (theme) => ({
  color:
    theme.palette.mode === "dark"
      ? theme.palette.grey[200]
      : theme.palette.text.primary,
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
  },
});

const outlinedExtraSx: SxProps<Theme> = (theme) => ({
  borderColor:
    theme.palette.mode === "dark"
      ? theme.palette.grey[500]
      : theme.palette.divider,
  "&:hover": {
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.grey[400]
        : theme.palette.text.primary,
  },
});

export type DialogTextActionButtonProps = Omit<
  ButtonProps,
  "variant" | "color"
> & {
  variant?: "text" | "outlined";
};

/**
 * Annuler / Fermer en pied de Dialog : le `Button` texte `primary` par défaut
 * est illisible en mode sombre sur fond paper ; ce composant force un contraste lisible.
 */
export const DialogTextActionButton = React.forwardRef<
  HTMLButtonElement,
  DialogTextActionButtonProps
>(function DialogTextActionButton(
  { variant = "text", sx, ...props },
  ref
) {
  return (
    <Button
      ref={ref}
      variant={variant}
      color="inherit"
      {...props}
      sx={[
        dialogSecondaryActionSx,
        ...(variant === "outlined" ? [outlinedExtraSx] : []),
        ...(Array.isArray(sx) ? sx : sx != null ? [sx] : []),
      ]}
    />
  );
});
